import React from 'react'

export default function Header() {
  return (
    <div>
      <div className="navbar top-pegado bg-base-100">
  <div className="flex-1">
    <a className="btn btn-ghost text-xl">BusIA</a>
  </div>
  <div className="flex-auto">
    <ul className="menu menu-horizontal px-1">
      <li><a>Inicio</a></li>
      <li><a>Nosotros</a></li>
      <li><a>Contacto</a></li>
      <li><a>Cuenta</a></li>
      {/* <li>
        <details>
          <summary>Parent</summary>
          <ul className="bg-base-100 rounded-t-none p-2">
            <li><a>Link 1</a></li>
            <li><a>Link 2</a></li>
          </ul>
        </details>
      </li> */}
    </ul>
    </div>
  <div className="flex-none">
    
  
    
    <div className="dropdown dropdown-end">
      <div tabIndex={0} role="button" className="btn btn-ghost btn-circle avatar">
        <div className="w-10 rounded-full">
          <img
            alt="Tailwind CSS Navbar component"
            src="https://img.daisyui.com/images/stock/photo-1534528741775-53994a69daeb.webp" />
        </div>
      </div>
      <ul
        tabIndex={0}
        className="menu menu-sm dropdown-content bg-base-100 rounded-box z-[1] mt-3 w-52 p-2 shadow">
        <li>
          <a className="justify-between">
            Profile
            {/* <span className="badge">New</span> */}
          </a>
        </li>
        <li><a>Settings</a></li>
        <li><a>Logout</a></li>
      </ul>
    </div>
  </div>
</div>
    </div>
  )
}
